<template>
  <b-container fluid>
    <b-row>
      <b-col md="4">
        <div class="cBody" :style="`width: ${20}rem; height: ${30}rem;`">
          <div class="cPhoto m-1">
            <b-img
              class="cImg"
              fluid
              :src="`/api/v1/people/${peopleDetail.id}/photo/profile`"
              alt="Profile"
            />
          </div>
        </div>
      </b-col>

      <b-col md="8">
        <b-row>
          <b-col md="6">
            <blockquote class="blockquote">
              <b-row>
                <b-col md="4">
                  <span class="my-4">Pohlaví:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.sex }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Věk:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.age }} let</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Národnost:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.nationality }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Etnikum:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.ethnic }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Titul:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.degree }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Pohlaví:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.sex }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Řidičák:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.drivingLicense.join(', ') }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Jazyky:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.language.join(', ') }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Kategorie:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.cathegory.join(', ') }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Komparz:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ convertBool(peopleDetail.komparz) }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Nahota:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ convertBool(peopleDetail.naked) }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">V prádle:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ convertBool(peopleDetail.underwear) }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Kam.Zkuš.:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ convertBool(peopleDetail.cameraExperience) }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Tetování:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.tatoo}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">Piercing:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ peopleDetail.piercing}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <span class="my-4">GDPR:</span>
                </b-col>
                <b-col md="8">
                  <span>{{ convertBool(peopleDetail.gdpr) }}</span>
                </b-col>
              </b-row>
            </blockquote>
          </b-col>
          <b-col md="6">
            <blockquote class="blockquote">
              <b-row>
                <b-col md="5">
                  <span class="my-4">Velikost:</span>
                </b-col>
                <b-col md="7">
                  <span v-if="!peopleDetail.sizes.childSize">{{ peopleDetail.sizes.dressSize }}</span>
                  <span
                    v-if="peopleDetail.sizes.childSize"
                  >{{ peopleDetail.sizes.childSize }} (dětská)</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Barva vlasů:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.hair }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Styl vlasů:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.hairStyle }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Stav nehtů:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.nails }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Délka nehtů:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.nailsLength }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Zuby:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.teeths }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Oči:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.eyes }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Brýle:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.glasses }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Ruce:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.hands }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Výška:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.sizes.height }} cm</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Hlava:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.sizes.head }} cm</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Krk:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.sizes.neck }} cm</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Hruď:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.sizes.breast }} cm</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Pas:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.sizes.waist }} cm</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Boky:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.sizes.hips }} cm</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <span class="my-4">Boty:</span>
                </b-col>
                <b-col md="7">
                  <span>{{ peopleDetail.sizes.shoes }}</span>
                </b-col>
              </b-row>
            </blockquote>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <blockquote class="blockquote">
              <b-row>
                <b-col md="2">
                  <span class="my-4">Adresa:</span>
                </b-col>
                <b-col md="10">
                  <span>
                    {{ peopleDetail.address }} &nbsp;
                    <a
                      :href="`https://www.google.com/maps/search/?api=1&query=${encodeURI(peopleDetail.address)}`"
                      target="_blank"
                    >
                      <img width="25px" height="25px" src="../assets/google-maps.svg" />
                    </a>
                  </span>
                  <span></span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="2">
                  <span class="my-4">E-mail:</span>
                </b-col>
                <b-col md="10">
                  <span>{{ peopleDetail.contactEmail }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="2">
                  <span class="my-4">Telefon:</span>
                </b-col>
                <b-col md="10">
                  <span>{{ peopleDetail.contactPhone }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="2">
                  <span class="my-4">Poznámka:</span>
                </b-col>
                <b-col md="10">
                  <span>{{ peopleDetail.description }}</span>
                </b-col>
              </b-row>
            </blockquote>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    peopleDetail: {}
  },
  data () {
    return {
    }
  },
  methods: {
    convertBool (input) {
      if (input === true) {
        return 'ANO'
      } else {
        return 'NE'
      }
    }
  },
  mounted () {

  }
})
</script>

<style>
.cBody {
  background-color: white;
  border: 0px solid rgb(133, 116, 116);
  border-radius: 0px;
  box-shadow: 5px 5px 0.3em 0 rgb(210, 210, 210);
  display: flex;
  flex-direction: column;
}

.cPhoto {
  display: flex;
  flex: 1;
  min-height: 0;
  background-image: radial-gradient(
    rgb(220, 220, 220) 30%,
    rgb(255, 255, 255) 75%
  );
}

.cImg {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
</style>
